import Vue from 'vue'
import Vuex from 'vuex'
import persistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const state = {
  WeChatSignature: {}, // 微信签名
  token: '', // 登录token
  isLogin: false, // 是否登录
  count:0
}

const getters = {
  getWeChatSignature: state => state.WeChatSignature,
  getToken: state => state.token,
  getIsLogin: state => state.isLogin,
}

const mutations = {
  resetStateMutations (state, flag) {
    flag && Object.assign(state, flag)
  },
  stateMutations (state, flag) {
    state[flag.key] = flag.data
  },
  countMutations(state,flag){
    console.log(flag)
    state.count=state.count+flag
  }
}

const actions = {
  resetStateActions ({ commit }) {
    commit('resetStateMutations', state)
  },
  stateActions ({ commit }, flag) {
    commit('stateMutations', flag)
  },
  countActions({commit},flag){
    commit('countMutations',flag)
  }
}

const store = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins: [persistedState({ storage: window.localStorage })]
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js